<template>
  <div>
    <Nav />
    <!-- 主要内容区 -->
    <div class="flex pt-20 max-w-7xl mx-auto">
      <LeftNav activeItem="orderhistory" />
      <main class="flex-1  p-6">
        <div class="max-w-5xl">
                <div class="mb-8">
                    <h1 class="text-2xl font-bold text-gray-900">历史订单</h1>
                    <p class="text-gray-600 mt-1">查看已完成或已取消的历史租赁订单记录</p>
                </div>
                <div class="mb-6">
                    <div class="flex items-center justify-between mb-6">
                        <div class="flex items-center space-x-4">
                            <div class="relative">
                                <button id="timeFilterBtn"
                                    class="flex items-center space-x-2 bg-white border border-gray-300 px-4 py-2 rounded-lg text-sm hover:bg-gray-50">
                                    <span id="timeFilterText">近一个月</span>
                                    <div class="w-4 h-4 flex items-center justify-center">
                                        <i class="ri-arrow-down-s-line text-gray-500"></i>
                                    </div>
                                </button>
                                <div id="timeFilterDropdown"
                                    class="hidden absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 min-w-32">
                                    <div class="py-1">
                                        <button class="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
                                            data-value="week">近一周</button>
                                        <button
                                            class="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 bg-blue-50 text-primary"
                                            data-value="month">近一个月</button>
                                        <button class="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
                                            data-value="quarter">近三个月</button>
                                        <button class="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
                                            data-value="half-year">近半年</button>
                                        <button class="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
                                            data-value="year">近一年</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex space-x-1">
                            <button id="statusAll"
                                class="px-4 py-2 text-sm text-gray-600 hover:text-primary hover:bg-gray-50 rounded-full">全部状态</button>
                            <button id="statusCompleted"
                                class="px-4 py-2 text-sm text-primary bg-blue-50 rounded-full">已完成</button>
                            <button id="statusCancelled"
                                class="px-4 py-2 text-sm text-gray-600 hover:text-primary hover:bg-gray-50 rounded-full">已取消</button>
                        </div>
                    </div>
                    <div class="space-y-6">
                        <div class="bg-white rounded-lg border border-gray-200">
                            <div class="p-4 border-b border-gray-100">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-4">
                                        <span class="text-gray-500">订单编号：ORD202412280001</span>
                                        <span class="text-gray-500">租赁时间：2025-01-18 至 2025-01-25</span>
                                        <span class="text-gray-500">北京会展器材租赁有限公司</span>
                                    </div>
                                    <span class="text-green-600">已完成</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <div class="flex items-center space-x-6">
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20aluminum%20truss%20system%20for%20exhibition%20booth%2C%20modern%20equipment%2C%20clean%20white%20background%2C%20product%20photography&width=128&height=128&seq=truss001&orientation=squarish"
                                                alt="铝合金桁架系统" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">铝合金桁架系统</div>
                                            <div class="text-gray-500 text-sm">¥80 × 5</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Exhibition%20display%20stand%2C%20modern%20booth%20equipment%2C%20clean%20white%20background%2C%20product%20photography&width=128&height=128&seq=stand001&orientation=squarish"
                                                alt="展览展示架" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">展览展示架</div>
                                            <div class="text-gray-500 text-sm">¥60 × 10</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Exhibition%20display%20screen%2C%20digital%20signage%2C%20clean%20white%20background%2C%20product%20photography&width=128&height=128&seq=screen001&orientation=squarish"
                                                alt="指示牌" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">指示牌</div>
                                            <div class="text-gray-500 text-sm">¥45 × 8</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-4 border-t border-gray-100">
                                <div>
                                    <span class="text-gray-500">共 3 件商品</span>
                                </div>
                                <div class="flex items-center space-x-8">
                                    <div class="text-right">
                                        <div class="text-gray-500">总计：<span
                                                class="text-xl font-semibold text-gray-900">¥1250.00</span></div>
                                    </div>
                                    <div class="flex items-center space-x-3">
                                        <button
                                            class="border border-gray-300 text-gray-700 px-4 py-2 !rounded-button hover:bg-gray-50 transition-colors whitespace-nowrap text-sm">查看详情</button>
                                        <button
                                            class="bg-orange-500 text-white px-4 py-2 !rounded-button hover:bg-orange-600 transition-colors whitespace-nowrap text-sm">评价</button>
                                        <button
                                            class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm">再次购买</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg border border-gray-200">
                            <div class="p-4 border-b border-gray-100">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-4">
                                        <span class="text-gray-500">订单编号：ORD202412150002</span>
                                        <span class="text-gray-500">2024-12-15</span>
                                        <span class="text-gray-500">上海展览设备有限公司</span>
                                    </div>
                                    <span class="text-red-600">已取消</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <div class="flex items-center space-x-6">
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20booth%20backdrop%20display%20stand%2C%20portable%20trade%20show%20banner%20stand%2C%20white%20background%2C%20commercial%20product%20photography%2C%20clean%20modern%20design&width=128&height=128&seq=booth002&orientation=squarish"
                                                alt="展台背景墙" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">3x3 米便携式展台背景墙</div>
                                            <div class="text-gray-500 text-sm">¥200 × 2</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20sound%20system%20audio%20equipment%20for%20events%2C%20microphone%20and%20speakers%20set%2C%20exhibition%20rental%20equipment%2C%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=audio002&orientation=squarish"
                                                alt="音响设备" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">专业音响设备套装</div>
                                            <div class="text-gray-500 text-sm">¥150 × 1</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-4 border-t border-gray-100">
                                <div>
                                    <span class="text-gray-500">共 2 件商品</span>
                                </div>
                                <div class="flex items-center space-x-8">
                                    <div class="text-right">
                                        <div class="text-gray-500">总计：<span
                                                class="text-xl font-semibold text-gray-900">¥550.00</span></div>
                                    </div>
                                    <div class="flex items-center space-x-3">
                                        <button
                                            class="border border-gray-300 text-gray-700 px-4 py-2 !rounded-button hover:bg-gray-50 transition-colors whitespace-nowrap text-sm">查看详情</button>
                                        <button
                                            class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm">再次购买</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg border border-gray-200">
                            <div class="p-4 border-b border-gray-100">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-4">
                                        <span class="text-gray-500">订单编号：ORD202412080003</span>
                                        <span class="text-gray-500">2024-12-08</span>
                                        <span class="text-gray-500">广州展览器材租赁公司</span>
                                    </div>
                                    <span class="text-green-600">已完成</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <div class="flex items-center space-x-6">
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20lighting%20equipment%2C%20LED%20spotlight%20system%20for%20trade%20shows%2C%20modern%20lighting%20fixtures%2C%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=light002&orientation=squarish"
                                                alt="照明设备" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">LED 专业照明系统</div>
                                            <div class="text-gray-500 text-sm">¥120 × 6</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20interactive%20touch%20screen%20kiosk%20for%20exhibitions%2C%20digital%20display%20terminal%2C%20modern%20technology%20equipment%2C%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=kiosk002&orientation=squarish"
                                                alt="互动触摸屏" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">42 英寸互动触摸屏</div>
                                            <div class="text-gray-500 text-sm">¥180 × 3</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-4 border-t border-gray-100">
                                <div>
                                    <span class="text-gray-500">共 2 件商品</span>
                                </div>
                                <div class="flex items-center space-x-8">
                                    <div class="text-right">
                                        <div class="text-gray-500">总计：<span
                                                class="text-xl font-semibold text-gray-900">¥1260.00</span></div>
                                    </div>
                                    <div class="flex items-center space-x-3">
                                        <button
                                            class="border border-gray-300 text-gray-700 px-4 py-2 !rounded-button hover:bg-gray-50 transition-colors whitespace-nowrap text-sm">查看详情</button>
                                        <button
                                            class="bg-orange-500 text-white px-4 py-2 !rounded-button hover:bg-orange-600 transition-colors whitespace-nowrap text-sm">评价</button>
                                        <button
                                            class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm">再次购买</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg border border-gray-200">
                            <div class="p-4 border-b border-gray-100">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-4">
                                        <span class="text-gray-500">订单编号：ORD202411220004</span>
                                        <span class="text-gray-500">2024-11-22</span>
                                        <span class="text-gray-500">深圳会展设备有限公司</span>
                                    </div>
                                    <span class="text-green-600">已完成</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <div class="flex items-center space-x-6">
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20furniture%20set%2C%20modern%20booth%20tables%20and%20chairs%2C%20clean%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=furniture001&orientation=squarish"
                                                alt="展览家具" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">展览桌椅套装</div>
                                            <div class="text-gray-500 text-sm">¥90 × 8</div>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20carpet%20flooring%2C%20red%20carpet%20for%20trade%20shows%2C%20clean%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=carpet001&orientation=squarish"
                                                alt="地毯" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">展览地毯</div>
                                            <div class="text-gray-500 text-sm">¥35 × 20</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-4 border-t border-gray-100">
                                <div>
                                    <span class="text-gray-500">共 2 件商品</span>
                                </div>
                                <div class="flex items-center space-x-8">
                                    <div class="text-right">
                                        <div class="text-gray-500">总计：<span
                                                class="text-xl font-semibold text-gray-900">¥1420.00</span></div>
                                    </div>
                                    <div class="flex items-center space-x-3">
                                        <button
                                            class="border border-gray-300 text-gray-700 px-4 py-2 !rounded-button hover:bg-gray-50 transition-colors whitespace-nowrap text-sm">查看详情</button>
                                        <button
                                            class="bg-orange-500 text-white px-4 py-2 !rounded-button hover:bg-orange-600 transition-colors whitespace-nowrap text-sm">评价</button>
                                        <button
                                            class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm">再次购买</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg border border-gray-200">
                            <div class="p-4 border-b border-gray-100">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-4">
                                        <span class="text-gray-500">订单编号：ORD202411100005</span>
                                        <span class="text-gray-500">2024-11-10</span>
                                        <span class="text-gray-500">成都展览器材租赁公司</span>
                                    </div>
                                    <span class="text-red-600">已取消</span>
                                </div>
                            </div>
                            <div class="p-4">
                                <div class="flex items-center space-x-6">
                                    <div class="flex items-center space-x-4">
                                        <div class="w-16 h-16 bg-gray-100 rounded overflow-hidden">
                                            <img src="https://readdy.ai/api/search-image?query=Professional%20exhibition%20projector%20equipment%2C%20digital%20presentation%20system%2C%20clean%20white%20background%2C%20commercial%20product%20photography&width=128&height=128&seq=projector001&orientation=squarish"
                                                alt="投影设备" class="w-full h-full object-cover object-top">
                                        </div>
                                        <div>
                                            <div class="text-gray-900">高清投影设备</div>
                                            <div class="text-gray-500 text-sm">¥250 × 2</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between p-4 border-t border-gray-100">
                                <div>
                                    <span class="text-gray-500">共 1 件商品</span>
                                </div>
                                <div class="flex items-center space-x-8">
                                    <div class="text-right">
                                        <div class="text-gray-500">总计：<span
                                                class="text-xl font-semibold text-gray-900">¥500.00</span></div>
                                    </div>
                                    <div class="flex items-center space-x-3">
                                        <button
                                            class="border border-gray-300 text-gray-700 px-4 py-2 !rounded-button hover:bg-gray-50 transition-colors whitespace-nowrap text-sm">查看详情</button>
                                        <button
                                            class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap text-sm">再次购买</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-8">
                        <div class="flex items-center space-x-2">
                            <button
                                class="px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
                                disabled>
                                <div class="w-4 h-4 flex items-center justify-center">
                                    <i class="ri-arrow-left-s-line"></i>
                                </div>
                            </button>
                            <button class="px-3 py-2 text-sm bg-primary text-white rounded-lg">1</button>
                            <button class="px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">2</button>
                            <button class="px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">3</button>
                            <span class="px-2 text-gray-500">...</span>
                            <button class="px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg">8</button>
                            <button class="px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50">
                                <div class="w-4 h-4 flex items-center justify-center">
                                    <i class="ri-arrow-right-s-line"></i>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
      </main>
    </div>
    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import { getUserInfo, logout as userLogout } from "@/utils/api.js";
import { Message } from "element-ui";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import LeftNav from "@/components/LeftNav.vue";

export default {
  name: "UserCenter",
  components: {
    Nav,
    Footer,
    LeftNav,
  },
  data() {
    return {
      userInfo: {},
      userName: "",
      userEmail: "",
      userAvatar: "",
    };
  },
  mounted() {
    // this.loadUserInfo()
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.back();
    },

    // 加载用户信息
    async loadUserInfo() {
      try {
        const response = await api.user.getUserInfo();
        if (response.code === 200) {
          this.userInfo = response.data;
          this.userName = response.data.name || response.data.username || "";
          this.userEmail = response.data.email || "";
          this.userAvatar = response.data.avatar || "";
        } else {
          Message.warning("无法加载用户信息");
        }
      } catch (error) {
        console.error("加载用户信息失败:", error);
        Message.error("加载用户信息失败");
      }
    },

    // 跳转到订单页面
    goToOrders() {
      Message.info("即将跳转到订单页面");
      // 实际项目中可以替换为真实的订单页面路由
      // this.$router.push('/ucenter/orders')
    },

    // 跳转到个人资料页面
    goToProfile() {
      Message.info("即将跳转到个人资料页面");
      // 实际项目中可以替换为真实的个人资料页面路由
      // this.$router.push('/ucenter/profile')
    },

    // 跳转到账号设置页面
    goToSettings() {
      Message.info("即将跳转到账号设置页面");
      // 实际项目中可以替换为真实的账号设置页面路由
      // this.$router.push('/ucenter/settings')
    },

    // 跳转到帮助中心
    goToHelp() {
      Message.info("即将跳转到帮助中心");
      // 实际项目中可以替换为真实的帮助中心页面路由
      // this.$router.push('/help')
    },

    // // 退出登录
    // async logout() {
    //   try {
    //     const response = await userLogout();
    //     if (response.code === 200) {
    //       Message.success("退出登录成功");
    //       setTimeout(() => {
    //         this.$router.push("/login");
    //       }, 1500);
    //     } else {
    //       Message.error("退出登录失败");
    //     }
    //   } catch (error) {
    //     console.error("退出登录失败:", error);
    //     Message.error("退出登录失败");
    //   }
    // },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/ucenter/OrderHistory.vue